<template>
  <div>
    <sdPageHeader :title="$t('pages.installs.title')"> </sdPageHeader>
    <Main>
      <sdCards>
        <a-row :gutter="16">
          <a-col :span="4">
            <label> {{ $t('pages.installs.label-domain-name') }} </label>
            <DomainDropdownVue v-model:data="filter.domain" @filter-change="onFilterChange"  />
          </a-col>
          <a-col :span="4">
              <label> {{ $t('pages.installs.label-app') }} </label>
            <AppDropdownVue v-model:data="filter.app_title" @filter-change="onFilterChange" :id="0" />
          </a-col>
          <a-col :span="4">
            <label> {{ $t('pages.installs.label-install-date') }} </label>
            <DatePickerWrapper>
              <a-range-picker
                v-model:value="filter.install_date"
                @change="onDateChange"
                :placeholder="[$t('pages.installs.label-start-date'), $t('pages.installs.label-end-date')]"
              />
            </DatePickerWrapper>
          </a-col>
          <a-col :span="4">
            <label> {{ $t('pages.installs.label-install') }} </label>
            <a-select
              :placeholder="$t('common.choose')"
              style="width: 100%"
              v-model:value="filter.install"
              @change="onFilterChange"
            >
              <a-select-option :value="null">
                {{ $t('common.choose') }}
              </a-select-option>
              <a-select-option :value="1">
                {{ $t('pages.installs.table-installed') }}
              </a-select-option>
              <a-select-option :value="0">
                {{ $t('pages.installs.table-uninstalled') }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="4">
            <label> &nbsp;</label>
            <sdButton size="default" :outlined="true" type="success" style="width: 100%" @click="onClickFilter">
              {{ $t('pages.orders.filter') }}
            </sdButton>
          </a-col>
          <a-col :span="4">
            <label> &nbsp;</label>
            <SearchBoxVue v-model:text="filter.search" @text-changed="getTableContent()"/>
          </a-col>
        </a-row>
        <br />
<!-- textChanged -->
        <a-row :gutter="25">
          <a-col :sm="24" :xs="24">
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>
            <div v-else>
              <a-table
                class="table-responsive"
                :columns="columns"
                :data-source="tableContent"
                :pagination="{
                  pageSize: this.filter.pageSize,
                  showSizeChanger: true,
                  total: this.filter.total,
                  current: this.filter.current,
                }"
                @change="onTableChange"
                size="small"
              >
                <template #state="{ record }">
                  <a-space>
                    <a-tag :color="record.state ? 'green' : 'red'">
                      {{ record.state ? $t('pages.installs.table-installed') : $t('pages.installs.table-uninstalled') }}
                    </a-tag>
                  </a-space>
                </template>
              </a-table>
            </div>
          </a-col>
        </a-row>
      </sdCards>
    </Main>
  </div>
</template>

<script>
import { Main } from '@/view/styled';
import { DatePickerWrapper } from './overview/style';
import { dateToTr } from '@/utility/helper.js';
import AppDropdownVue from '@/components/dropdown/AppDropdown.vue';
import DomainDropdownVue from '@/components/dropdown/DomainDropdown.vue';
import SearchBoxVue from '@/components/search/SearchBox.vue';


export default {
  components: {
    Main,
    DatePickerWrapper,
    AppDropdownVue,
    DomainDropdownVue,
    SearchBoxVue
  },
  data() {
    return {
      isLoading: true,
      tableContent: [],
      isFilterNew: false,
      filter: {
        search: '',
        domain: null,
        app_title: null,
        install_date: null,
        install: null,
        current: 1,
        pageSize: 10,
        total: null,
      },
      columns: [
        {
          title: this.$t('pages.installs.table-domain-name'),
          dataIndex: 'domain',
          key: 'domain',
        },
        {
          title: this.$t('pages.installs.table-app-name'),
          dataIndex: 'app_title',
          key: 'app_title',
        },
        {
          title: this.$t('pages.installs.table-email'),
          dataIndex: 'email',
          key: 'email   ',
        },
        {
          title: this.$t('pages.installs.table-update-date'),
          dataIndex: 'update_date',
          key: 'update_date',
        },
        {
          title: this.$t('pages.installs.table-install-date'),
          dataIndex: 'install_date',
          key: 'install_date',
        },
        {
          title: this.$t('pages.installs.table-install-state'),
          dataIndex: 'state',
          key: 'state',
          slots: { customRender: 'state' },
        },
      ],
    };
  },
  created() {
    this.getTableContent();
  },
  methods: {
    onClickFilter() {
      this.isFilterNew = true;
      this.filter.current = 1;
      this.getTableContent();
      this.isFilterNew = false;
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.getTableContent();
      this.isFilterNew = false;
    },
    onDateChange(e) {
      this.isFilterNew = true;
      if (this.filter.install_date?.length < 1) {
        this.filter.install_date = null;
      }
    },
    onFilterChange(e) {
      this.isFilterNew = true;
    },
    getTableContent() {
      this.isLoading = true;
      this.$appAxios.post(this.$endpoints.installs_get, this.filter).then(resp => {
        if (resp.data.status === true) {
          var tableRecords = resp.data.data.tableData;
          this.filter.total = resp.data.data.total;
          this.tableContent = [];
          var _this = this;
          tableRecords.forEach(function(item, index) {
            _this.tableContent.push({
              key: item.id,
              domain: item.domain,
              app_title: item.app_title,
              email: item.admin_username,
              update_date: dateToTr(item.update_date),
              install_date: dateToTr(item.install_date),
              state: item.install,
            });
          });
        }
        this.isLoading = false;
      });
    },
  },
};
</script>
